import {axiosGet} from "../../../../common/Helper/AxiosHelper";
import {JOB_POST} from "../../../../tenant/Config/ApiUrl";

const state =  {
    jobPost: {},
}

const getters = {
    getJobPostDetails: state => {
        return state.jobPost
    }
};

const actions = {
    getJobPostDetails({commit, state}, jobPostId){
        commit('SET_LOADER', true)
        axiosGet(`${JOB_POST}/${jobPostId}`).then(({ data }) =>{
            commit('JOB_POST_DETAILS_DATA', data)
        }).finally(()=> commit('SET_LOADER', false))
    },
}

const mutations = {
    JOB_POST_DETAILS_DATA(state, data){
        state.jobPost = data;
    },
}

export default {
    state,
    actions,
    getters,
    mutations
}
